import styled from 'styled-components';

import arrow_down from 'assets/icons/arrow_down.svg';

interface Props {
  nowSelecting?: boolean;
  borderRadius?: string;
}

export const SelectComponent = styled.div<Props>`
  &.select {
    display: flex;
    align-items: center;

    position: relative;

    width: 100%;
    min-height: 55px;
    padding: 5px 20px;

    color: var(--blue12);
    font-size: 16px;

    border-radius: ${({ nowSelecting, borderRadius }) => {
      const radius = borderRadius || '7px'

      return nowSelecting ? `${radius} ${radius} 0 0` : radius
    }};
    transition: 0.3s;

    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.27);
    cursor: pointer;
    background: #fff;

    &:after {
      content: '';
      position: absolute;
      right: 18px;
      top: 18px;

      width: 15px;
      height: 15px;

      transition: all 0.2s;
      transform: ${({ nowSelecting }) =>
        nowSelecting ? 'scaleY(-1)' : 'unset'};

      background: no-repeat center;
      background-size: contain;
      background-image: url(${arrow_down});
    }
  }
`;

export const SelectOptions = styled.div<Props>`
  &.select__options {
    display: flex;
    flex-direction: column;

    position: absolute;
    z-index: 3;

    top: ${({ nowSelecting }) => (nowSelecting ? '100%' : '50%')};
    left: 0;
    right: 0;

    height: ${({ nowSelecting }) => (nowSelecting ? 'unset' : '0')};

    opacity: ${({ nowSelecting }) => (nowSelecting ? '1' : '0')};

    padding-top: ${({ nowSelecting }) => (nowSelecting ? '15px' : '0')};

    background: #fff;
    border-radius: 0 0 25px 25px;
    box-shadow: ${({ nowSelecting }) =>
      nowSelecting ? '0px 7px 6px rgb(66 0 102 / 25%)' : 'unset'};
    transition: all 0.3s;
  }
`;

export const OptionsContainer = styled.div`
  &.select__options-container {
    max-height: 290px;
    margin: 0 15px 15px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background: var(--graycd);
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--blue12);
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb:hover {
      opacity: 0.9;
    }
  }
`;

export const Option = styled.div`
  padding: 5px;
  cursor: pointer;
  &:hover {
    background-color: #1278d73d;
  }
`;

export const SelectFakeDropShadow = styled.div<Props>`
  display: ${({ nowSelecting }) => (nowSelecting ? 'block' : 'none')};
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
`;
